import { ChangeDetectorRef, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormObjectListComponent } from '../../../../shared/forms/form-object-list.component';
import { FormObjectComponent } from '../../../../shared/forms/form-object.component';
import { FormValidation } from '../../../../shared/forms/form-validation';
import { Estimate } from '../../models/estimates/estimate';
import { PartEstimate } from '../../models/estimates/part-estimate';
import { LaborEstimate } from '../../models/estimates/labor-estimate';
import { MaterialEstimate } from '../../models/estimates/material-estimate';
import { EstimateType } from '../../models/estimates/estimate-type';
import { EstimateComopnent } from '../estimate.component';
import { PartEstimateComponent } from '../part-estimate/part-estimate.component';
import { LaborEstimateComponent } from '../labor-estimate/labor-estimate.component';
import { MaterialEstimateComponent } from '../material-estimate/material-estimate.component';

@Component({
  selector: 'estimate-list',
  templateUrl: './estimate-list.component.html'
})
export class EstimateListComponent extends FormObjectListComponent<FormObjectComponent, Estimate> {
  // Used to validate parent form before adding new estimate.
  @Input() form : UntypedFormGroup;
  
  // This does not pick up the derived classes so broke them out separately.
  @ViewChildren(EstimateComopnent) override objectForms: QueryList<EstimateComopnent>;

  @ViewChildren(PartEstimateComponent) partForms: QueryList<PartEstimateComponent>;
  @ViewChildren(LaborEstimateComponent) laborForms: QueryList<LaborEstimateComponent>;
  @ViewChildren(MaterialEstimateComponent) materialForms: QueryList<MaterialEstimateComponent>;
  
  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  public isPart(type: EstimateType): boolean {
    return type == EstimateType.Part;
  }

  public isLabor(type: EstimateType): boolean {
    return type == EstimateType.Labor;
  }

  public isMaterial(type: EstimateType): boolean {
    return type == EstimateType.HazardousMaterial;
  }
  
  public get laborTotal(): number {
    return this.laborForms?.reduce((sum, item) => sum + item.total, 0) ?? 0;
  }

  public get partTotal(): number {
    return this.partForms?.reduce((sum, item) => sum + item.total, 0) ?? 0;
  }

  public get materialTotal(): number {
    return this.materialForms?.reduce((sum, item) => sum + item.total, 0) ?? 0;
  }

  public get total(): number {
    return this.laborTotal + this.partTotal + this.materialTotal;
  }

  public override validateForm(): void {
    super.validateForm();
    if (!this.formCompleted) return;

    // Check if the correction titles are filled.
    this.formCompleted = this.form.valid;
    if (!this.formCompleted) return;
    
    this.partForms?.forEach(partForm => {
      if (!FormValidation.isValid(partForm.form)) this.formCompleted = false;
    });
    if (!this.formCompleted) return;
    
    this.laborForms?.forEach(laborForm => {
      if (!FormValidation.isValid(laborForm.form)) this.formCompleted = false;
    });
    if (!this.formCompleted) return;

    this.materialForms?.forEach(materialForms => {
      if (!FormValidation.isValid(materialForms.form)) this.formCompleted = false;
    });
  }

  public addPart(): void {
    this.validateForm();
    if (!this.formCompleted) return;

    super.add(new PartEstimate(null, null, null, null, null, null, null));
  }

  public addLabor(): void {
    this.validateForm();
    if (!this.formCompleted) return;

    super.add(new LaborEstimate(null, null, null, null, null));
  }

  public addMaterial(): void {
    this.validateForm();
    if (!this.formCompleted) return;

    super.add(new MaterialEstimate(null, null, null, null));
  }
}
